import * as z from "zod";

export const enableGorgiasEscalation = {
  name: "enableGorgiasEscalation" as const,
  input: z.null(),
  output: z.object({ success: z.boolean() }),
};
